
export default {
    name: "ExportCsvMixin",
    methods: {
        _createExportCsv(headers, entities){
            let csvHeader = this._getCsvHeader(headers);
            let csvData = this._getCsvData(entities, headers);
            let date = new Date(Date.now());

            const blob = new Blob([csvHeader+csvData], {type: 'text/plain'})
            const e = document.createEvent('MouseEvents'),
                a = document.createElement('a');
            a.download = this.$route.name+'-'+date.getFullYear()+'-'+date.getMonth()+'-'+date.getDate()+'.csv';
            a.href = window.URL.createObjectURL(blob);
            a.dataset.downloadurl = ['text/csv', a.download, a.href].join(':');
            e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            a.dispatchEvent(e);
            this.emptyMessage();
        },
        _getCsvHeader(header){
            let headerData = [
                ['"Export dat z platformy Backoffice"'],
                ['"URL"', '"' + window.location.href + '"'],
                ['"Čas vygenerování"', '"' + this.$_datetime_format(Date.now()/1000) + '"'],
                ['"Uživatel"', '"' + this.$store.getters.getFullName + '"'],
                ['\n']
            ];

            let columns = [];
            for(const column in header){
                columns.push('"'+header[column].name+'"');
            }
            columns.push(['\n']);
            headerData.push(columns);

            return this._getCsvFormatDataFromArray(headerData);
        },

        _getCsvData(entities, header){
            let response = [];
            let timeColumns = ['timestamp', 'date_created', 'timestamp_created', 'date_updated', 'timestamp_updated'];
            let filterArray = this.selectedEntities.map(str => { return Number(str)});
            for(const key in entities){
                let entity = entities[key];
                if(filterArray.length > 0 && !filterArray.includes(Number(entity.id))){
                    continue;
                }
                let line = [];
                for(const columnName in header){
                    let columnValue;
                    if(timeColumns.includes(columnName)){
                        columnValue = entity[columnName] ? this.$_datetime_format(entity[columnName]) : '';
                    }else if(header[columnName].hasOwnProperty('callback')){
                        try {
                            columnValue = header[columnName].callback(entity, key, columnName);
                        }catch (error){
                            columnValue = '';
                        }
                    }else {
                        if(entity[columnName] !== null && entity[columnName] !== undefined) {
                            columnValue = String(entity[columnName]);
                        }else{
                            columnValue = '';
                        }
                    }
                    line.push(columnValue? '"'+columnValue+'"' : '""');
                }
                response.push(line);
            }

            return this._getCsvFormatDataFromArray(response);
        },

        _getCsvFormatDataFromArray(data){
            let response = [];
            for(const line of data){
                response.push(line.join(';'));
            }
            return response.join('\n');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/exportCsv.js